import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import postsReducer from './postsSlice';
import singlePostReducer from './singlePostSlice';
import logInOutReducer from './logInOutSlice';

export const store = configureStore({
  reducer: {
    posts: postsReducer,
    singlePost: singlePostReducer,
    logInOut: logInOutReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
